import React, { useRef } from 'react'
import {
  CaretDown,
  CaretUp,
  Tooltip
  // @ts-ignore
} from '@netbasequid/core'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { get } from 'lodash'

import { Theme } from '../../../features/ui/types'
import { useDisplayTheme } from '../../../hooks/useUiState'
import {
  StyledOuterBox,
  StyledTitle,
  StyledValueSection,
  StyledValue,
  StyledVariationIcon,
  StyledVariationValue
} from './index.css'

export type TileProps = {
  title: string
  value: string
  colorSetting?: string
  variation?: {
    trend: 'up' | 'down' | 'none'
    value: string
  }
  size?: 'sm' | 'md' | 'lg'
  infoTooltipContent?: React.ReactNode
  isDisabled?: boolean
}

export const getColor = (colorSetting: string, theme: Theme) =>
  colorSetting ? get(sys[theme], colorSetting)?.default : colorSetting

export const variationhandler = (
  variation: {
    trend: 'up' | 'down' | 'none'
    value: string
  },
  theme: Theme
) => {
  const positiveColor = sys[theme].semantic.positive.default
  const negativeColor = sys[theme].semantic.negative.default
  const defaultTextColor = sys[theme].text.placeholder

  switch (variation.trend) {
    case 'up':
      return (
        <>
          <StyledVariationIcon>
            <CaretUp color={positiveColor} />
          </StyledVariationIcon>
          <StyledVariationValue theme={theme} color={positiveColor}>
            {variation.value}
          </StyledVariationValue>
        </>
      )
    case 'down':
      return (
        <>
          <StyledVariationIcon>
            <CaretDown color={negativeColor} />
          </StyledVariationIcon>
          <StyledVariationValue theme={theme} color={negativeColor}>
            {variation.value}
          </StyledVariationValue>
        </>
      )
    case 'none':
      return (
        <StyledVariationValue theme={theme} color={defaultTextColor}>
          {variation.value}
        </StyledVariationValue>
      )
    default:
      return <></>
  }
}

const Tile = ({
  title,
  value,
  variation,
  colorSetting,
  size = 'sm',
  infoTooltipContent,
  isDisabled = false
}: TileProps) => {
  const theme = useDisplayTheme() as Theme
  const contentRef = useRef<HTMLDivElement>(null)

  return (
    <Tooltip mode={theme} followCursor={false} enabled content={infoTooltipContent}>
      <StyledOuterBox
        isDisabled={isDisabled}
        theme={theme}
        size={size}
        color={colorSetting && getColor(colorSetting, theme)}
        ref={contentRef as React.RefObject<HTMLDivElement>}>
        <StyledTitle size={size} theme={theme}>
          {title}
        </StyledTitle>
        <StyledValueSection>
          <StyledValue theme={theme} hasMarginRight={variation !== undefined}>
            {value}
          </StyledValue>
          {variation && variationhandler(variation, theme)}
        </StyledValueSection>
      </StyledOuterBox>
    </Tooltip>
  )
}

export default Tile
